import styles from "./main.module.scss";

const ProductNotAvailableMessage = ({ canBuyProduct, name }) => {
  if (canBuyProduct) return null;
  return (
    <span className={`${styles.productNotAvailableText} t-bg-3`}>
      {name || "Item"} is currently not available.
    </span>
  );
};

export default ProductNotAvailableMessage;
